import { FadeIn, MaskedLine } from "@/components/Reveal";

const PageHero = ({ eyebrow, title, lead, children }) => (
  <section
    className="relative overflow-hidden bg-paper pb-16 pt-36 md:pb-24 md:pt-48"
    data-testid="page-hero"
  >
    <div
      aria-hidden="true"
      className="absolute right-[-120px] top-[-120px] h-[440px] w-[440px] rounded-full bg-primary/[0.07] blur-3xl"
    />
    <div
      aria-hidden="true"
      className="absolute inset-0 opacity-[0.35]"
      style={{
        backgroundImage:
          "linear-gradient(to right, rgba(15,23,42,0.05) 1px, transparent 1px)",
        backgroundSize: "clamp(60px, 8vw, 120px) 100%",
      }}
    />
    <div className="relative mx-auto max-w-7xl px-6">
      <FadeIn delay={0.05}>
        <span className="eyebrow">{eyebrow}</span>
      </FadeIn>
      <h1 className="mt-7 max-w-4xl font-display text-[clamp(2.4rem,5.4vw,4.5rem)] font-semibold leading-[1.02] tracking-tight text-ink">
        <MaskedLine delay={0.1}>{title}</MaskedLine>
      </h1>
      {lead && (
        <FadeIn delay={0.3}>
          <p className="mt-7 max-w-2xl text-lg leading-relaxed text-soot md:text-xl">{lead}</p>
        </FadeIn>
      )}
      {children}
    </div>
  </section>
);

export default PageHero;
